var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.configurationMode)?_c('a',{attrs:{"href":_vm.href},on:{"click":_vm.onClick}},[_c('icon',{attrs:{"name":_vm.name}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }